// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__16dS7","itemTitle":"ClientEmergencyInfo_itemTitle__mXYkg","itemText":"ClientEmergencyInfo_itemText__3sonf"};